import type { PathConfig } from "@react-navigation/native";

import { SCREENS } from "../screens";
import type { AuthV2StackParamList } from "./types";

// Kept apart from the navigator in index.ts so that code which only needs to
// know the sign-in stack's paths (the cut-over gate's route questions) can
// read them without pulling in any screen.

const {
  LoginCode,
  LoginVerify,
  LoginPassword,
  ForgotPasswordV2,
  AuthConflict,
  RegisterV2,
  RegisterDetails,
  RegisterPassword,
} = SCREENS;

export const authV2NavConfig: PathConfig<AuthV2StackParamList> = {
  initialRouteName: LoginCode.name,
  screens: {
    [LoginCode.name]: LoginCode.path,
    [LoginVerify.name]: LoginVerify.path,
    [LoginPassword.name]: LoginPassword.path,
    [ForgotPasswordV2.name]: ForgotPasswordV2.path,
    [AuthConflict.name]: AuthConflict.path,
    [RegisterV2.name]: RegisterV2.path,
    [RegisterDetails.name]: RegisterDetails.path,
    [RegisterPassword.name]: RegisterPassword.path,
  },
};
